import React from "react";
import { ArrowRight } from "lucide-react";
import { Page } from "@/components/Page";
import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { Reveal, RevealStagger, StaggerItem } from "@/components/Reveal";
import { Button } from "@/components/Button";
import { IMAGES, INDUSTRIES } from "@/data/site";

const Industries = () => {
  return (
    <Page>
      <SEO title="Industries" description="Speed Shipping Agencies supports logistics across maritime, agriculture, manufacturing, FMCG, infrastructure, energy, government projects and industrial equipment." />

      <PageHero
        eyebrow="Industries We Serve"
        title="Sector-specific logistics expertise"
        intro="Tailored maritime and logistics capabilities for the industries that drive global trade — each supported with dedicated operational understanding."
        image={IMAGES.aerialPort}
      />

      <section className="py-24 lg:py-32">
        <div className="ssa-container">
          <RevealStagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="industries-grid">
            {INDUSTRIES.map((ind, i) => (
              <StaggerItem key={ind.slug} className={i < 3 ? "lg:col-span-2" : ""}>
                <div
                  data-testid={`industries-grid-card-${ind.slug}`}
                  className="group relative flex flex-col h-full min-h-[260px] rounded-2xl overflow-hidden border border-[color:var(--ssa-border-subtle)] transition-shadow duration-300 hover:shadow-[0_22px_55px_rgba(8,28,58,0.16)]"
                >
                  <div className="absolute inset-0">
                    <img src={ind.image} alt={ind.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(8,28,58,0.35) 0%, rgba(8,28,58,0.88) 100%)" }} />
                  </div>
                  <div className="relative mt-auto p-7">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl glass-dark text-turquoise mb-4">
                      <ind.icon className="h-5 w-5" />
                    </div>
                    <h3 className="text-xl text-white">{ind.name}</h3>
                    <p className="mt-2 text-sm text-white/75 leading-relaxed">{ind.text}</p>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </RevealStagger>
        </div>
      </section>

      <section className="pb-24 lg:pb-32">
        <div className="ssa-container">
          <div className="rounded-3xl navy-gradient grain relative overflow-hidden p-10 lg:p-16 text-center">
            <Reveal>
              <h2 className="text-white text-3xl sm:text-4xl max-w-2xl mx-auto leading-tight">
                Logistics partnerships engineered around your sector
              </h2>
              <p className="mt-5 text-white/75 max-w-xl mx-auto">
                Whatever your industry, our integrated services adapt to its operational realities.
              </p>
              <div className="mt-8 flex justify-center">
                <Button to="/services" variant="light" size="xl">Explore our services <ArrowRight className="h-5 w-5" /></Button>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default Industries;
